module.exports = __webpack_public_path__ + "static/img/product_banner.dd10904.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product_banner.png
// module id = 67bS
// module chunks = 10